export function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export const nextUntil = (elem, endId) => {
  // Setup siblings array
  const siblings = [];

  // Get the next sibling element
  elem = elem.nextElementSibling;

  // As long as a sibling exists
  while (elem) {
    // Break if we match the passed HTML element id
    if (elem.getAttribute('id') === endId) {
      break;
    }

    // Otherwise, push it to the siblings array
    siblings.push(elem);

    // Get the next sibling element
    elem = elem.nextElementSibling;
  }

  return siblings;
};

export function clone(array) {
  return JSON.parse(JSON.stringify(array));
}

export const closeOnEsc = (callback) => {
  const close = (e) => {
    if (e.keyCode === 27) {
      callback();
    }
  };
  window.addEventListener('keydown', close);
  // return () => window.removeEventListener('keydown', close);
};

export function truncateString(str, num) {
  if (str.length > num) {
    return `${str.slice(0, num)}...`;
  }
  return str;
}

/**
 * @param {number} num
 * @link https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
 * @returns {string}
 */
export function ordinal(num) {
  return ['st', 'nd', 'rd'][((((num + 90) % 100) - 10) % 10) - 1] || 'th';
}

export function brandColors() {
  return {
    ambikiBlue: '#2948a0',
    ambikiSalmon: '#f18e69',
    ambikiPink: '#ef3dc0',
    ambikiTurquoise: '#3cceb7',
    ambikiYellow: '#f1b241',
  };
}

export function updateCountToHeader(countElementId, resultElementId, totalAttribute = 'total') {
  const countElement = document.getElementById(countElementId);
  const resultElement = document.getElementById(resultElementId);
  if (countElement && resultElement) {
    const totalElementValue = countElement.dataset[totalAttribute];
    const totalCount = totalElementValue ? parseInt(totalElementValue, 10) : 0;
    const formattedTotalCount = Number.isNaN(totalCount) ? '0' : totalCount.toLocaleString();
    resultElement.textContent = `(${formattedTotalCount})`;
  }
}
